<template>
  <div v-if="bindingFunction">
    <v-layout>
      <v-flex v-if="displayJudgeConfirmation">
        <v-autocomplete v-model="judge" :items="judges" label="Juez a cargo" itemText="lastName" itemValue="pk"
                        prepend-icon="mdi-gavel" light no-data-text="No hay datos disponibles" dense
                        :loading="loadingJudges" class="user-select">
          <template slot="item" slot-scope="props">{{ getFullName(props.item) }}</template>
        </v-autocomplete>
      </v-flex>
      <v-flex>
        <v-btn :disabled="loadingJudges || saving" color="primary" class="mr-4 mb-0 mt-1 py-0" small @click="bindingFunction">
          {{ buttonText }}
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
  <div v-else></div>
</template>

<script>
const ALL_JUDGES_OPTION = 0

export default {
  props: {
    user: Object,
    permissions: Object
  },

  data () {
    return {
      saving: false,
      buttonText: '',
      bindingFunction: null,
      loadingJudges: false,
      judge: null,
      judges: []
    }
  },

  computed: {
    fetchPath () {
      return (this.permissions.canConfirmCommittee) ? 'case_file/committee/users' : 'case_file/court/users'
    },
    displayJudgeConfirmation () {
      return this.permissions.canConfirmCommittee || this.permissions.canConfirmCourt
    }
  },

  methods: {
    transfer () {
      this.updateCaseFile('transfer')
    },
    discharge () {
      this.$router.push({ name: 'nuevoDescargo', params: { id: this.$route.params.id } })
    },
    confirmCommittee () {
      this.updateCaseFile('confirm_committee', { user: this.judge })
    },
    resolveCommittee () {
      this.$router.push({ name: 'nuevaResolucionComite', params: { id: this.$route.params.id } })
    },
    notifyCommittee () {
      this.$router.push({ name: 'nuevaNotificacionComite', params: { id: this.$route.params.id } })
    },
    appeal () {
      this.$router.push({ name: 'nuevaApelacion', params: { id: this.$route.params.id } })
    },
    confirmCourt () {
      this.updateCaseFile('confirm_court', { user: this.judge })
    },
    resolveCourt () {
      this.$router.push({ name: 'nuevaResolucionTribunal', params: { id: this.$route.params.id } })
    },
    notifyCourt () {
      this.updateCaseFile('notify_court')
    },
    updateCaseFile (path, payload = {}) {
      this.saving = true
      this.axios
        .put(`case_file/${path}/${this.$route.params.id}`, payload)
        .then((response) => {
          this.emitUpdate(response.data)
          this.saving = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
          this.saving = false
        })
    },
    emitUpdate (caseFile) {
      this.$emit('update', caseFile)
    },
    judgesSelectAllText () {
      let text = (this.permissions.canConfirmCommittee) ? 'Comité de disciplina' : 'Tribunal de Apelaciones'
      return { pk: ALL_JUDGES_OPTION, itemText: text, lastName: text }
    },
    fetchJudges () {
      this.loadingJudges = true
      let defaultElement = this.judgesSelectAllText()
      this.axios
        .get(this.fetchPath)
        .then(response => {
          this.judges = response.data
          this.judges.push(defaultElement)
          this.loadingJudges = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    getFullName (item) {
      if (!item.hasOwnProperty('firstName')) return item.lastName
      return item.lastName + ', ' + item.firstName
    },
    setInitialData () {
      if (this.permissions.canTransfer) {
        this.buttonText = 'Dar traslado'
        this.bindingFunction = this.transfer
      } else if (this.permissions.canDischarge) {
        this.buttonText = 'Presentar descargo'
        this.bindingFunction = this.discharge
      } else if (this.permissions.canConfirmCommittee) {
        this.fetchJudges()
        this.buttonText = 'Seleccionar juez'
        this.bindingFunction = this.confirmCommittee
      } else if (this.permissions.canResolveCommittee) {
        this.buttonText = 'Nueva resolución'
        this.bindingFunction = this.resolveCommittee
      } else if (this.permissions.canNotifyCommittee) {
        this.buttonText = 'Notificar a club(es)'
        this.bindingFunction = this.notifyCommittee
      } else if (this.permissions.canAppeal) {
        this.buttonText = 'Apelar'
        this.bindingFunction = this.appeal
      } else if (this.permissions.canConfirmCourt) {
        this.fetchJudges()
        this.buttonText = 'Seleccionar juez'
        this.bindingFunction = this.confirmCourt
      } else if (this.permissions.canResolveCourt) {
        this.buttonText = 'Nueva resolución'
        this.bindingFunction = this.resolveCourt
      } else if (this.permissions.canNotifyCourt) {
        this.buttonText = 'Notificar a club(es)'
        this.bindingFunction = this.notifyCourt
      } else {
        this.buttonText = ''
        this.bindingFunction = null
      }
      this.judge = (this.user) ? this.user.pk : ALL_JUDGES_OPTION
    }
  },

  mounted () {
    this.setInitialData()
  },

  watch: {
    permissions: {
      handler () {
        this.setInitialData()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.v-text-field {
  padding-top: 0;
  margin-top: 0;
  height: 20px !important;
}
.user-select {
  max-width: 300px;
}
</style>
